import axios from 'axios';

import {
    BACKEND_URL
} from "../backendURL";


class PermissionService {

    getMyPermissions = (filters) => {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)
        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };
        let request_url = BACKEND_URL + "/api/core/mypermissions/";

        return axios.get(request_url, config);
    }

    getMyPermissionsTree = (filters) => {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)
        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };
        let request_url = BACKEND_URL + "/api/core/permission-tree/";

        return axios.get(request_url, config);
    }

    async getMemberPermissions (token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };
        let request_url = BACKEND_URL + "/api/core/mypermissions/";

        return await axios.get(request_url, config);
    }


}

export default new PermissionService();